/* eslint-disable no-duplicate-case */
import * as types from '../constants';
import { STATUS } from '../constants';
import { reject, resolve } from '../api';

export const initialSourceState = {
  sources: [],
  sourcesIOCsCountsAndIsActive: [],
  sourcesCount: 0,
  source: null,
  loadSourcesStatus: STATUS.IDLE,
  loadSourceStatus: STATUS.IDLE,
  loadSourcesIocCountsStatus: STATUS.IDLE,
  loadSourcesIocCountsAndIsActiveStatus: STATUS.IDLE,
  createEmptySourceStatus: STATUS.IDLE,
  createURLSourceStatus: STATUS.IDLE,
  createFileSourceStatus: STATUS.IDLE,
  activateSourceStatus: STATUS.IDLE,
  publishSourceStatus: STATUS.IDLE,
};

export default (state = initialSourceState, action) => {
  switch (action?.type) {
    case types.LOAD_SOURCES: {
      return {
        ...state,
        loadSourcesStatus: STATUS.LOADING,
      };
    }
    case resolve(types.LOAD_SOURCES): {
      const { sourcesIOCsCountsAndIsActive } = state;
      let sources = action?.payload?.results;

      if (sourcesIOCsCountsAndIsActive.length > 0) {
        if (sources.length > 0) {
          for (const source of sources) {
            for (const ioc_count_source of sourcesIOCsCountsAndIsActive) {
              if (source.uuid === ioc_count_source?.uuid) {
                // source.ioc_count = ioc_count_source?.ioc_count;
                source.is_active = ioc_count_source?.is_active;
                source.tags = ioc_count_source?.tags;
              }
            }
          }
        }
      }
      return {
        ...state,
        sources: sources,
        sourcesCount: action?.payload?.count,
        loadSourcesStatus: STATUS.LOADED,
      };
    }
    case reject(types.LOAD_SOURCES):
      return {
        ...state,
        error: true,
        sources: [],
        loadSourcesStatus: STATUS.ERROR,
      };

    case types.LOAD_SOURCE: {
      return {
        ...state,
        loadSourceStatus: STATUS.LOADING,
      };
    }
    case resolve(types.LOAD_SOURCE): {
      return {
        ...state,
        source: action?.payload,
        loadSourceStatus: STATUS.LOADED,
      };
    }
    case reject(types.LOAD_SOURCE):
      return {
        ...state,
        error: true,
        source: {},
        loadSourceStatus: STATUS.ERROR,
      };

    case types.LOAD_SOURCES_IOC_COUNTS_AND_IS_ACTIVE: {
      return {
        ...state,
        loadSourcesIocCountsAndIsActiveStatus: STATUS.LOADING,
      };
    }
    case resolve(types.LOAD_SOURCES_IOC_COUNTS_AND_IS_ACTIVE): {
      const { sources } = state;
      let sourcesIOCsCountsAndIsActive = action?.payload?.results;
      if (sources && sources?.length > 0) {
        for (const source of sources) {
          for (const ioc_count_source of sourcesIOCsCountsAndIsActive) {
            if (source?.uuid === ioc_count_source?.uuid) {
              // source.ioc_count = ioc_count_source?.ioc_count;
              source.is_active = ioc_count_source?.is_active;
              source.tags = ioc_count_source?.tags;
            }
          }
        }
      }
      return {
        ...state,
        sources: sources,
        sourcesIOCsCountsAndIsActive: sourcesIOCsCountsAndIsActive,
        loadSourcesIocCountsAndIsActiveStatus: STATUS.LOADED,
      };
    }
    case reject(types.LOAD_SOURCES_IOC_COUNTS_AND_IS_ACTIVE):
      return {
        ...state,
        error: true,
        loadSourcesIocCountsAndIsActiveStatus: STATUS.ERROR,
      };

    case types.LOAD_SOURCES_IOC_COUNTS: {
      return {
        ...state,
        loadSourcesIocCountsStatus: STATUS.LOADING,
      };
    }
    case resolve(types.LOAD_SOURCES_IOC_COUNTS): {
      const { sources } = state;
      let sources_ioc_counts = action?.payload;

      let new_sources = [];
      if (sources && sources?.length > 0) {
        for (const source of sources) {
          for (const ioc_count_source of sources_ioc_counts) {
            if (source?.uuid === ioc_count_source?.uuid) {
              source.ioc_count = ioc_count_source?.total_ioc_count;
              source.collection_status = ioc_count_source?.collection_status;
            }
          }
          new_sources.push(source);
        }
      }
      return {
        ...state,
        sources: new_sources,
        loadSourcesIocCountsStatus: STATUS.LOADED,
      };
    }
    case reject(types.LOAD_SOURCES_IOC_COUNTS):
      return {
        ...state,
        error: true,
        loadSourcesIocCountsStatus: STATUS.ERROR,
      };

    case types.CREATE_EMPTY_SOURCE: {
      return {
        ...state,
        createEmptySourceStatus: STATUS.LOADING,
      };
    }
    case resolve(types.CREATE_EMPTY_SOURCE): {
      const { sources } = state;
      return {
        ...state,
        newlyCreatedSource: action?.payload,
        // sources: [action?.payload, ...sources],
        createEmptySourceStatus: STATUS.LOADED,
      };
    }
    case reject(types.CREATE_EMPTY_SOURCE): {
      return {
        ...state,
        error: true,
        createEmptySourceStatus: STATUS.ERROR,
      };
    }

    case types.CREATE_URL_SOURCE: {
      return {
        ...state,
        createURLSourceStatus: STATUS.LOADING,
      };
    }
    case resolve(types.CREATE_URL_SOURCE): {
      const { sources } = state;
      return {
        ...state,
        // sources: [action?.payload, ...sources],
        createURLSourceStatus: STATUS.LOADED,
      };
    }

    case types.CREATE_FILE_SOURCE: {
      return {
        ...state,
        createFileSourceStatus: STATUS.LOADING,
      };
    }
    case resolve(types.CREATE_FILE_SOURCE): {
      const { sources } = state;
      return {
        ...state,
        // sources: [action?.payload, ...sources],
        createFileSourceStatus: STATUS.LOADED,
      };
    }

    case resolve(types.DELETE_SOURCE): {
      return {
        ...state,
        sources: state?.sources?.filter((f) => f?.uuid !== action?.uuid),
      };
    }

    case resolve(types.CHANGE_SOURCE_SCOPE): {
      const { sources } = state;

      const index = sources?.findIndex(
        (f) => f?.uuid === action?.payload?.uuid,
      );
      return {
        ...state,
        sources: [
          ...sources?.slice(0, index),
          action?.payload,
          ...sources?.slice(index + 1),
        ],
      };
    }

    case types.ACTIVATE_SOURCE: {
      return {
        ...state,
        activateSourceStatus: STATUS.LOADING,
      };
    }
    case resolve(types.ACTIVATE_SOURCE): {
      const { sources } = state;
      const index = sources?.findIndex(
        (f) => f?.uuid === action?.payload?.uuid,
      );
      let updateSource = Object.assign({}, sources[index]);
      updateSource = {
        ...updateSource,
        is_active: action?.payload?.is_active,
      };

      return {
        ...state,
        sources: [
          ...sources?.slice(0, index),
          updateSource,
          ...sources?.slice(index + 1),
        ],
        activateSourceStatus: STATUS.LOADED,
      };
    }

    case resolve(types.UPDATE_SOURCE): {
      const { sources } = state;

      const index = sources?.findIndex(
        (f) => f?.uuid === action?.payload?.uuid,
      );
      return {
        ...state,
        sources: [
          ...sources?.slice(0, index),
          action?.payload,
          ...sources?.slice(index + 1),
        ],
      };
    }

    case resolve(types.UPDATE_FILE_SOURCE): {
      const { sources } = state;

      const index = sources?.findIndex(
        (f) => f?.uuid === action?.payload?.uuid,
      );
      return {
        ...state,
        sources: [
          ...sources?.slice(0, index),
          action?.payload,
          ...sources?.slice(index + 1),
        ],
      };
    }

    case types.ADD_IOC_JSON:
      return {
        ...state,
      };

    case resolve(types.ADD_IOC_JSON):
      return {
        ...state,
        mergeAPIscoreDetails: action?.payload,
        detailsStatus: STATUS.LOADED,
      };

    case types.PUBLISH_SOURCE: {
      return {
        ...state,
        publishSourceStatus: STATUS.LOADING,
      };
    }
    case resolve(types.PUBLISH_SOURCE): {
      return {
        ...state,
        publishSourceStatus: STATUS.LOADED,
        sources: state?.sources?.filter((f) => f?.uuid !== action?.uuid),
      };
    }

    default:
      return state;
  }
};
